import React from 'react';
import callApi from './../../utils/apicaler';
import Checkbox from '@material-ui/core/Checkbox';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';

import NavMeauBar from './const_childer/nav_meau';
import '.././puclic/scss/style.css';    
import Proce from '../pageCreate/Proce';
import axios from 'axios';   
import {
  Link,
  Redirect
} from "react-router-dom";

    
class AddProduct extends React.Component{
    constructor(props){
            super(props);

            this.state = {
            	status:0,
                products : [],
                file:"",
                productsPai:[],
                alertCustom:"",
                redirct:0,
                color:"",
                size:"",
                loai:"",
                setDis:"",
                setcolor:"",
                image:"",
                postColor:
                [
                    {
                      "color": "#eeeeee"
                    },
                    {
                      "color": "#888888"
                    },
                    {
                      "color": "#222222"
                    },
                    {
                      "color": "#cc0000"
                    },
                    {
                      "color": "#660000"
                    },
                    {
                      "color": "#ffffff"
                    },
                    {
                      "color": "#ccffff"
                    },
                    {
                      "color": "#99ffff"
                    },
                    {
                      "color": "#66ffff"
                    },
                    {
                      "color": "#33ffff"
                    },
                    {
                      "color": "#00ffff"
                    },
                    {
                      "color": "#ffccff"
                    },
                    {
                      "color": "#ccccff"
                    },
                    {
                      "color": "#99ccff"
                    },
                    {
                      "color": "#66ccff"
                    },
                    {
                      "color": "#33ccff"
                    },
                    {
                      "color": "#00ccff"
                    },
                    {
                      "color": "#00cc33"
                    },
                    {
                      "color": "#ff9933"
                    },
                    {
                      "color": "#cc9933"
                    },
                    {
                      "color": "#999933"
                    },
                    {
                      "color": "#669933"
                    },
                    {
                      "color": "#339933"
                    },
                    {
                      "color": "#009933"
                    },
                    {
                      "color": "#ff6633"
                    },
                    {
                      "color": "#cc6633"
                    },
                    {
                      "color": "#996633"
                    },
                    {
                      "color": "#666633"
                    },
                    {
                      "color": "#336633"
                    },
                    {
                      "color": "#006633"
                    },
                    {
                      "color": "#ff3333"
                    },
                    {
                      "color": "#cc3333"
                    },
                    {
                      "color": "#993333"
                    },
                    {
                      "color": "#663333"
                    },
                    {
                      "color": "#333333"
                    },
                    {
                      "color": "#003366"
                    },
                    {
                      "color": "#ff0066"
                    },
                    {
                      "color": "#cc0066"
                    },
                    {
                      "color": "#990066"
                    },
                    {
                      "color": "#660066"
                    },
                    {
                      "color": "#330066"
                    },
                    {
                      "color": "#000066"
                    },
                    {
                      "color": "#00bb00"
                    },
                    {
                      "color": "#005500"
                    },
                    {
                      "color": "#0000ee"
                    },
                    {
                      "color": "#000088"
                    },
                    {
                      "color": "#fff"
                    },
                    {
                      "color": "#8b0016"
                    },
                    {
                      "color": "#b2001f"
                    },
                    {
                      "color": "#c50023"
                    },
                    {
                      "color": "#df0029"
                    },
                    {
                      "color": "#e54646"
                    },
                    {
                      "color": "#ee7c6b"
                    },
                    {
                      "color": "#f5a89a"
                    },
                    {
                      "color": "#fcdad5"
                    },
                    {
                      "color": "#8e1e20"
                    },
                    {
                      "color": "#b6292b"
                    },
                    {
                      "color": "#c82e31"
                    },
                    {
                      "color": "#e33539"
                    },
                    {
                      "color": "#eb7153"
                    },
                    {
                      "color": "#f19373"
                    },
                    {
                      "color": "#f6b297"
                    },
                    {
                      "color": "#fcd9c4"
                    },
                    {
                      "color": "#945305"
                    },
                    {
                      "color": "#bd6b09"
                    },
                    {
                      "color": "#d0770b"
                    },
                    {
                      "color": "#ec870e"
                    },
                    {
                      "color": "#f09c42"
                    },
                    {
                      "color": "#f5b16d"
                    },
                    {
                      "color": "#face9c"
                    },
                    {
                      "color": "#fde2ca"
                    },
                    {
                      "color": "#976d00"
                    },
                    {
                      "color": "#c18c00"
                    },
                    {
                      "color": "#d59b00"
                    },
                    {
                      "color": "#f1af00"
                    },
                    {
                      "color": "#f3c246"
                    },
                    {
                      "color": "#f9cc76"
                    },
                    {
                      "color": "#fce0a6"
                    },
                    {
                      "color": "#feebd0"
                    },
                    {
                      "color": "#9c9900"
                    },
                    {
                      "color": "#c7c300"
                    },
                    {
                      "color": "#dcd800"
                    },
                    {
                      "color": "#f9f400"
                    },
                    {
                      "color": "#fcf54c"
                    },
                    {
                      "color": "#fef889"
                    },
                    {
                      "color": "#fffab3"
                    },
                    {
                      "color": "#fffbd1"
                    },
                    {
                      "color": "#367517"
                    },
                    {
                      "color": "#489620"
                    },
                    {
                      "color": "#50a625"
                    },
                    {
                      "color": "#5bbd2b"
                    },
                    {
                      "color": "#83c75d"
                    },
                    {
                      "color": "#afd788"
                    },
                    {
                      "color": "#c8e2b1"
                    },
                    {
                      "color": "#e6f1d8"
                    },
                    {
                      "color": "#006241"
                    },
                    {
                      "color": "#007f54"
                    },
                    {
                      "color": "#008c5e"
                    },
                    {
                      "color": "#00a06b"
                    },
                    {
                      "color": "#00ae72"
                    },
                    {
                      "color": "#67bf7f"
                    },
                    {
                      "color": "#98d0b9"
                    },
                    {
                      "color": "#c9e4d6"
                    },
                    {
                      "color": "#00676b"
                    },
                    {
                      "color": "#008489"
                    },
                    {
                      "color": "#009298"
                    },
                    {
                      "color": "#00a6ad"
                    },
                    {
                      "color": "#00b2bf"
                    },
                    {
                      "color": "#6ec3c9"
                    },
                    {
                      "color": "#99d1d3"
                    },
                    {
                      "color": "#cae5e8"
                    },
                    {
                      "color": "#103667"
                    },
                    {
                      "color": "#184785"
                    },
                    {
                      "color": "#1b4f93"
                    },
                    {
                      "color": "#205aa7"
                    },
                    {
                      "color": "#426eb4"
                    },
                    {
                      "color": "#7388c1"
                    },
                    {
                      "color": "#94aad6"
                    },
                    {
                      "color": "#bfcae6"
                    },
                    {
                      "color": "#211551"
                    },
                    {
                      "color": "#2d1e69"
                    },
                    {
                      "color": "#322275"
                    },
                    {
                      "color": "#3a2885"
                    },
                    {
                      "color": "#511f90"
                    },
                    {
                      "color": "#635ba2"
                    },
                    {
                      "color": "#8273b0"
                    },
                    {
                      "color": "#a095c4"
                    },
                    {
                      "color": "#38044b"
                    },
                    {
                      "color": "#490761"
                    },
                    {
                      "color": "#52096c"
                    },
                    {
                      "color": "#5d0c7b"
                    },
                    {
                      "color": "#79378b"
                    },
                    {
                      "color": "#8c63a4"
                    },
                    {
                      "color": "#aa87b8"
                    },
                    {
                      "color": "#c9b5d4"
                    },
                    {
                      "color": "#64004b"
                    },
                    {
                      "color": "#780062"
                    },
                    {
                      "color": "#8f006d"
                    },
                    {
                      "color": "#a2007c"
                    },
                    {
                      "color": "#af4a92"
                    },
                    {
                      "color": "#c57cac"
                    },
                    {
                      "color": "#d2a6c7"
                    },
                    {
                      "color": "#e8d3e3"
                    },
                    {
                      "color": "#ececec"
                    },
                    {
                      "color": "#d7d7d7"
                    },
                    {
                      "color": "#c2c2c2"
                    },
                    {
                      "color": "#b7b7b7"
                    },
                    {
                      "color": "#a0a0a0"
                    },
                    {
                      "color": "#898989"
                    },
                    {
                      "color": "#707070"
                    },
                    {
                      "color": "#555555"
                    },
                    {
                      "color": "#363636"
                    },
                    {
                      "color": "#000000"
                    }]
            }
        }


    componentDidMount(){
            var {match} = this.props;

            callApi('views', 'GET', null).then(res =>{
                if(res.status == 200){
                    this.setState({ productsPai : res.data });
                }
            })


            if(match){
                var id = match.params.id;
                callApi(`addProduct/${id}`, 'GET', null).then(res =>{
                	this.setState({
                        status :res.status,
						products : res.data
					}) 
                  
                })
            }
            
    }
    onDeleteViews = (id) =>{
        
        if(confirm('ban co chan chan muon xoa ? ')){ // eslint-disable-line
            {this.deleteCallViews(id)}
            
        }
        
    }
    deleteCallViews = (id) =>{
        var {productsPai} = this.state;
        callApi(`deleteviews/${id}`, 'GET', null).then(res =>{
                if( res.status === 200){
                    var index = this.findIndex(productsPai, id);
                    if(index !== -1){
                        productsPai.splice(index, 1);
                        this.setState({
                            productsPai:productsPai
                        })
                    }
                }
            })
    }
    findIndex = (products, id) =>{
        var result = -1;
            products.forEach((post, index)=>{
                if(post._id === id){
                    result = index;
                }
            })
        return result;
    }

        onChangeImage2(e){
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          this.setState({
            file2: file,
            image2: reader.result
          });
        }

        reader.readAsDataURL(file)
        
    }

    onChangeImage1=(e)=>{
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          this.setState({
            file: file,
            image: reader.result
          });
        }

        reader.readAsDataURL(file)
    }
    onChangeSize=(e)=>{
        this.setState({
            size: e.target.value
        });
    }
    onChangeLoai=(e)=>{
        this.setState({
            loai: e.target.value
        });
    }
    click_color=()=>{
        this.setState({
            setDis: "display_not"
        });
    }
    setColor=(color)=>{
        this.setState({
            setDis: "", setColor:color
        });

    }

    showCompleImg = (datas, main)=>{
        var result = null;
        result = datas.map((products, index)=>{
            return ( 
                products.products === main.products ? 
                    <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 custom_col" id={ products.products === main.products ? "" : "display_not"} key={index}>
                        <div className="img_views">
                            <Checkbox onClick={()=> this.onDeleteViews(products._id, products.imgeFile)}/>
                            <img src={products.imgeFile1} width="100px" height="100px"/>
                            <p>{products.color}</p>
                        </div>
                    </div>

                : ""

            )
        })
        return result;
    }

    showClor = (datas)=>{
        var result = null;
        result = datas.map((products, index)=>{
            return ( 
                <tr align="middle" key={index}>
                    <td style={{fontSize: "15px", fontFamily: "tahoma"}} bgcolor={products.color}>
                        <span onClick={()=> this.setColor(products.color)} style={{color: products.color}}> {products.color}</span>
                    </td>
                    <td style={{fontSize: "15px", fontFamily: "tahoma"}} bgcolor={products.color}>
                        <span onClick={()=> this.setColor(products.color)} style={{color: products.color}}> {products.color}</span>
                    </td>
                    <td style={{fontSize: "15px", fontFamily: "tahoma"}} bgcolor={products.color}>
                        <span onClick={()=> this.setColor(products.color)} style={{color: products.color}}> {products.color}</span>
                    </td>
                    <td style={{fontSize: "15px", fontFamily: "tahoma"}} bgcolor={products.color}>
                        <span onClick={()=> this.setColor(products.color)} style={{color: products.color}}> {products.color}</span>
                    </td>
                    <td style={{fontSize: "15px", fontFamily: "tahoma"}} bgcolor={products.color}>
                        <span onClick={()=> this.setColor(products.color)} style={{color: products.color}}> {products.color}</span>
                    </td>
                </tr>
            )
        })
        return result;
    }

    callApiFunc = (name) => {
    	var { file,products,setColor,size, loai } = this.state;
        var param = file
        console.log(file)
        let data = new FormData();
        data.append('image', file);
        console.log(data)
        
        let config = {
            method: 'post',
            url: 'https://api.imgur.com/3/image',
            headers: { 
                'Authorization': 'Client-ID 20fa25cfc3dea77'
            },
            data : data
        };
        
        axios(config)
        .then((res) => {
            const {data} = res.data;
            var link = data.link;

            axios.post('https://t5f1805b29d37b001382761af.herokuapp.com/create/addimg',{
                imgeFile1:link,
                products:products.products,
                color:setColor,
                size:size,
                loai:loai
            })
                .then((res)=> {
                    this.setState({redirct : res.status})
                })
                .catch((err)=> {
                    console.log(err);
                })
            setTimeout(function(){ window.location.href = "/manager"; }, 3000);
        })   

        this.setState({alertCustom : "alertCustom"})

            

            
        }
        
       
 






    render(){
    	var {postColor, setDis,image, setColor, productsPai, products, status, alertCustom, redirct, file} = this.state;
        return(  
        	<div className="container-fluid custom_fluid" id={alertCustom !== "" ? "alertCustom" : ""}>
				<div className="close_imgc1"><CloseIcon/> </div>
				<div className="conten_image_product">
					<div className="row" id={setDis}>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div className="view-wapper">
                                    <div className="img_view">
                                        <img src={products.imgeFile1} style={{width:"100%"}} />
                                    </div>
                                <div className="row custom_row">
                                   {this.showCompleImg(productsPai, products)} 
                                </div>
                            </div>
                        </div>
                        <div className="row custom_row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="send_mail">
                                    <label htmlFor="upload-photo">Chọn ảnh...</label>
                                    <br/>
                                    <img src={image} width="150px"/>
           
                                    <div>{file === "" ? "" : <div><span>Name:</span> <span style={{color:"#3889d1"}}>{file.name}</span></div> }</div>
                                    <br/>
                                    <div>{file === "" ? "" : <div><span>Kích thước:</span> <span style={{color:"#fa1e2d"}}>{file.size}kb</span></div> }</div>
                                    <input style={{display:"none"}} id="upload-photo" name="imgeFile1" className="form-control" type="file" onChange={this.onChangeImage1}/>
                                    <br/>
                                    <br/>
                                    <label htmlFor="upload-color">Chọn màu...</label>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <input placeholder={setColor} id="upload-color" style={{background:setColor}} type="text" onClick={this.click_color}/>
                                    <br/>
                                    <br/>
                                    <input placeholder="size" className="form-check-input" type="text" name="size" onChange={this.onChangeSize}/>
                                    <br/>
                                    <br/>
                                    <input placeholder="LOẠI" className="form-check-input" type="text" name="loai" onChange={this.onChangeLoai}/>
                                    <button style={{display:"block",marginTop:"24PX"}} type="submit" onClick={this.callApiFunc} >Them</button>
                                </div>
                            </div>
                        </div>
                        
						
					</div>
                    <div className="wapper_color" id={setDis === "" ? "display_not" : ""}>
                            <table cellPadding="2" cellSpacing="0" border="1" style={{borderCollapse: "collapse"}}>
                                <tbody>
                                    {this.showClor(postColor)}
                                </tbody>
                            </table>
                        </div>
				</div>	
                {redirct === 200 ? <Redirect to='manager'  /> : ""}
                {alertCustom !== "" ? <div className=""><Proce /></div> : ""}     
			</div>	    
        	)
    }
    
}

export default AddProduct;